import {
    ADD_ATTACHMENT_ENQUIRY,
    ADD_ATTACHMENT_ENQUIRY_SUCCESS,
    ADD_ATTACHMENT_ENQUIRY_FAILURE,
    RESET_ATTACHMENT_ENQUIRY,
    GET_ATTACHMENT_ENQUIRY,
    GET_ATTACHMENT_ENQUIRY_SUCCESS,
    GET_ATTACHMENT_ENQUIRY_FAILURE,
    RESET_GET_ATTACHMENT_ENQUIRY,
} from "../actions/attachmentEnquiryAction";

export interface AttachmentEnquiryState {
    loading: boolean;
    data: any;
    error: any;
    success: boolean;
    getLoading: boolean;
    list: any[];
    tablelength: number;
    getError: any;
    getSuccess: boolean;
}

const initialState: AttachmentEnquiryState = {
    loading: false,
    data: null,
    error: null,
    success: false,

    getLoading: false,
    list: [],
    tablelength: 0,
    getError: null,
    getSuccess: false,
};

const attachmentEnquiryReducer = (
    state = initialState,
    action: any
): AttachmentEnquiryState => {
    switch (action.type) {
        case ADD_ATTACHMENT_ENQUIRY:
            return {
                ...state,
                loading: true,
                error: null,
                success: false,
            };

        case ADD_ATTACHMENT_ENQUIRY_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                success: true,
            };

        case ADD_ATTACHMENT_ENQUIRY_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
                success: false,
            };

        case RESET_ATTACHMENT_ENQUIRY:
            return {
                ...state,
                loading: false,
                data: null,
                error: null,
                success: false,
            };

        case GET_ATTACHMENT_ENQUIRY:
            return {
                ...state,
                getLoading: true,
                getError: null,
                getSuccess: false,
            };

        case GET_ATTACHMENT_ENQUIRY_SUCCESS:
            return {
                ...state,
                getLoading: false,
                list: action.payload?.data || [],
                tablelength: action.payload?.tablelength || 0,
                getSuccess: true,
            };

        case GET_ATTACHMENT_ENQUIRY_FAILURE:
            return {
                ...state,
                getLoading: false,
                getError: action.payload,
                list: [],
                tablelength: 0,
                getSuccess: false,
            };

        case RESET_GET_ATTACHMENT_ENQUIRY:
            return {
                ...state,
                getLoading: false,
                list: [],
                tablelength: 0,
                getError: null,
                getSuccess: false,
            };

        default:
            return state;
    }
};

export default attachmentEnquiryReducer;